module.exports = __webpack_public_path__ + "static/media/profileInfo_blue.e67e02ec.svg";